import type { ComponentChildren, FunctionalComponent } from 'preact';

import { BlockBubbledCard1CheckIcon } from '../__check-icon/block-bubbled-card-1__check-icon.js';
import { cnBlockBubbledCard1 } from '../block-bubbled-card-1.constants.js';

import './block-bubbled-card-1__list-item.css';

export interface BlockBubbledCard1ListItemProps {
    children?: ComponentChildren;
}

export const BlockBubbledCard1ListItem: FunctionalComponent<BlockBubbledCard1ListItemProps> = ({ children }) => (
    <li className={cnBlockBubbledCard1('list-item')}>
        <BlockBubbledCard1CheckIcon />
        <span>{children}</span>
    </li>
);
